import React from "react";
import { SectionList, TouchableOpacity, View, Text } from "react-native";
import { useNavigation, useIsFocused } from "@react-navigation/native";
import t from "@constants/localization";
import SupportListSubheader from "./SupportListSubheader";
import SupportListItem from "./SupportListItem";
import RecentTickets from "./RecentTickets";
import CancelDialog from "../SupportTickets/CancelOrReopenDialog";
import cancelSupportTicket from "../utils/cancelSupportTicket";

const PATH = "screens/SupportTree/SupportList/SupportList";

const SupportListView = ({
  supportList,
  isParent,
  handleReloadList = () => {},
  fetching = false,
}) => {
  const [showCancelModal, setShowCancelModal] = React.useState(false);
  const [ticket_id, setTicketId] = React.useState(null);
  const [issueLevel1, setIssueLevel1] = React.useState(null);
  const navigation = useNavigation();
  const isFocused = useIsFocused();

  return (
    <>
      <CancelDialog
        visible={showCancelModal}
        onRequestClose={() => setShowCancelModal(false)}
        title={t(`${PATH}/cancelTicket`)}
        message={t(`${PATH}/cnfmTicketCancellation`)}
        buttons={[
          {
            text: t(`${PATH}/no`),
            onPress: () => setShowCancelModal(false),
            style: "cancel",
          },
          {
            text: t(`${PATH}/yes`),
            onPress: () => {
              // cancel the ticket here
              cancelSupportTicket(ticket_id, issueLevel1, async () => {
                setShowCancelModal(false);
                handleReloadList();
              });
            },
            style: "okay",
          },
        ]}
      />

      <SectionList
        contentContainerStyle={{ marginTop: 8 }}
        sections={supportList.children}
        keyExtractor={(item) => item.title}
        renderItem={({ item }) => {
          if (item.render === "RECENT_TICKETS") {
            return (
              <RecentTickets
                {...item}
                handleReloadList={handleReloadList}
                onCancelTicket={(id, issue_level_1) => {
                  setTicketId(id);
                  setIssueLevel1(issue_level_1);
                  setShowCancelModal(true);
                }}
                fetching={fetching}
              />
            );
          }
          return <SupportListItem {...item} isFocused={isFocused} />;
        }}
        renderSectionHeader={({ section: { title } }) => {
          return <SupportListSubheader title={title} />;
        }}
      />
    </>
  );
};

export default SupportListView;
